
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class extends Vue {
  @Prop() private tabs!: any[]
  private myTabs: any[] = []
  private id = '24'

  mounted () {
    this.myTabs = this.tabs
  }

  switchHanlder (item: any) {
    this.myTabs = this.myTabs.map((item: any) => {
      item.status = false
      return item
    })
    item.status = true
    this.id = item.id
    this.$emit('switchHanlder', item.id)
  }

  detail () {
    console.log(this.id)
    window.location.href = (`/detailPage.html?menuId=${this.id}`)
  }
}
